import { IconLoader2 } from "@tabler/icons-react";
import FullySupportedAddressSelection from "./FullySupportedAddressSelection";
import Title from "./ui/Title";
import Input from "./ui/Input";
import Button from "./ui/Button";
const  EstimateCharacteristicsFromAddress = ({getEstimatedCharacteristicsFromAddress, loading, zipcode, huisnummer, setZipcode, setHuisnummer}: {getEstimatedCharacteristicsFromAddress: () => void, loading: boolean, zipcode: string, huisnummer: string, setZipcode: React.Dispatch<React.SetStateAction<string>>, setHuisnummer: React.Dispatch<React.SetStateAction<string>>}) => {



    return (
        <div className="flex flex-col gap-2">
                <div className="w-full flex flex-col gap-2">
                    <div className="text-center flex flex-row gap-2 items-center">
                        <Title title="Address Lookup" />
                        {loading && <IconLoader2 className="w-4 h-4 animate-spin" />}
                    </div>
                    <div>
                        Select from fully supported addresses:
                        <FullySupportedAddressSelection setZipcode={setZipcode} setHuisnummer={setHuisnummer} />
                    </div>
                    <div className="flex flex-col gap-2">
                        <div>
                            <Input
                                label="Zipcode"
                                value={zipcode}
                                onChange={(value) => setZipcode(value)}
                            />
                        </div>
                        <div>
                            <Input
                                label="Huisnummer"
                                value={huisnummer}
                                onChange={(value) => setHuisnummer(value)}
                            />
                        </div>
                        <Button
                            onClick={getEstimatedCharacteristicsFromAddress}
                        >
                            {loading ? 'Loading...' : 'Estimate'}
                        </Button>
                    </div>
                </div>
        </div>
    );
};

export default EstimateCharacteristicsFromAddress;